import { TpDataContext } from '../../../data/interfaces';
import { TpDashboardContext } from '../dashboard/interfaces';

export enum DBACTIONVARTYPES {
  Value = 'Value', // a singleton value
}

export interface TpDbActionVar_Value {
  type: DBACTIONVARTYPES.Value;
  content: any;
}

export type TpDbActionVar = TpDbActionVar_Value;

export interface TpDashboardActionContext {
  dataContext: TpDataContext;
  dashboardContext: TpDashboardContext;
  actionDef: any;
  dispatch: any;
  currentStepNr: number;
  variables: { [id: string]: TpDbActionVar };
}

export interface TpDbActionStepDefinition {
  stepType: string;
  execute: (ctx: TpDashboardActionContext, stepDef: any, onCompleted: () => void) => void;
  getJsonSchema: () => any;
}
